'use client';

import { memo } from 'react';

/**
 * Loading skeleton for gallery board cards.
 * Matches GalleryBoardCard's 150px square size with border and padding.
 */
export const GalleryBoardSkeleton = memo(() => {
  return (
    <div className="size-[150px] rounded-12 border border-neutral-5 bg-white p-1 dark:bg-neutral-2">
      <div className="size-full animate-pulse rounded-8 bg-neutral-4" />
    </div>
  );
});

GalleryBoardSkeleton.displayName = 'GalleryBoardSkeleton';
